<template>
  <div class="upgrade-plan" :class="tier.name.toLowerCase()">
    <div class="header">
      <div v-if="tier.onSale" class="ribbon">
        <div class="on-sale">On Sale</div>
      </div>
      <h3>{{ $t(`${view}.TIERS_${tier.name}_HEADER`) }}</h3>
      <h4 v-if="tier.onSale" class="slashed-price">
        Regular <strong>{{ slashedPrice }}</strong>
      </h4>
      <h4 v-else>as low as</h4>
      <h2>{{ minimumPrice }}</h2>
      <h4>per month (USD)</h4>
      <md-button @click="onPick"
                 class="md-raised md-primary">
        Select
      </md-button>
    </div>
    <div class="divider"/>
    <ul class="content">
      <li v-for="feature in features">
        <md-icon class="included">{{ includedIcon(feature) }}</md-icon>
        <span v-html="$t(`${view}.TIERS_${tier.name}_${feature.name}_LABEL`)"/>
        <img v-if="feature.new" :src="nowWithAIBadge()" class="new-feature" alt="New Feature" />
      </li>
    </ul>
  </div>
</template>
<script>
import style from 'brave-upgrade/components/plan.scss'
import {centsToDollars} from 'brave-utils/string'

export default {
  name: 'UpgradePlan',
  data: () => {
    return {
    }
  },
  computed: {
    minimumPrice: function () {
      return centsToDollars(this.tier.minimum)
    },
    slashedPrice: function () {
      return centsToDollars(this.tier.slashed)
    }
  },
  methods: {
    onPick: function (ev) {
      this.onSubmit({ev, type: this.tier.id})
    },
    includedIcon: function (feature) {
      if (feature.included === true || feature.included.includes(this.tier.name)) {
        return 'check';
      } else {
        return 'close';
      }
    },
    nowWithAIBadge: function () {
      return require(`assets/img/shared/badges/now-with-ai.png`);
    }
  },
  props: ['tier', 'features', 'view', 'onSubmit']
}
</script>